import { create } from "zustand";

interface PaymentState {
  paymentProgressStatus: boolean;
  setPaymentProgressStatus: (status: boolean) => void;
}

export const usePaymentStore = create<PaymentState>((set) => ({
  paymentProgressStatus: false,
  setPaymentProgressStatus: (status: boolean) =>
    set({ paymentProgressStatus: status }),
}));
